class CartRemoveButton extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault()
      document.dispatchEvent(new CustomEvent('cart:loading'))
      const cartLineItem = event.target.closest('[data-update-target]')
      this.closest('cart-items').updateQuantity(
        cartLineItem.dataset.itemKey,
        0,
        this.dataset.name,
        cartLineItem.dataset.handle
      )
    })
  }

  disconnectedCallback() {
    this.removeEventListener('click', (event) => {})
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    document.addEventListener('cart:loading', () => {
      this.loading(true)
    })
    document.addEventListener('cart:loaded', () => {
      this.loading(false)
    })

    this.form = this.querySelector('form')
    this.cartOverlay = document.querySelector('[data-cart-overlay]')

    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status'
    )

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))

    this.form.addEventListener('submit', this.submitForm.bind(this))

    this.bubble = document.getElementById('cart-icon-bubble')

    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((data) => {
        this.bubble.innerHTML = data.item_count
      })
      .catch((e) => {
        console.error(e)
      })

    this.checkGwpThreshold().then((r) => r)

    document.dispatchEvent(new CustomEvent('cart:loaded'))
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.debouncedOnChange.bind(this))
    this.form.removeEventListener('submit', this.submitForm.bind(this))
  }

  submitForm() {
    this.querySelector('form').addEventListener('submit', (event) => {
      if (event.submitter == document.getElementById('notification-submit')) {
        event.preventDefault()
      }
    })
  }

  onChange(event) {
    document.dispatchEvent(new CustomEvent('cart:loading'))
    const cartLineItem = event.target.closest('[data-update-target]')
    this.updateQuantity(
      cartLineItem.dataset.itemKey,
      event.target.value,
      document.activeElement.getAttribute('name'),
      cartLineItem.dataset.handle
    )
  }

  getSectionsToRender() {
    const isCartPage = document.body.classList.contains('template-cart')
    const cartId = isCartPage ? 'cart' : 'mini-cart'
    return [
      {
        id: cartId,
        section: document.getElementById(cartId).dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ]
  }

  renderCart(state, line, quantity, name) {
    document.dispatchEvent(new CustomEvent('cart:loading'))
    const parsedState = JSON.parse(state)
    window.__CART__ = parsedState
    this.classList.toggle('is-empty', parsedState.item_count === 0)

    const cartTemplate = document.querySelector('.main-cart-template')
    if (cartTemplate != undefined && parsedState.item_count === 0) {
      cartTemplate.classList.add('is-empty')
    }

    if (name === 'gwp') {
      localStorage.setItem('_gwp', 'removed')
    } else {
      localStorage.removeItem('_gwp')
    }

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id)

      if (!elementToReplace) return

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      )
    })

    if (line && quantity && name) {
      document.dispatchEvent(
        new CustomEvent('cart-updated', {
          detail: {
            line,
            quantity,
            name,
          },
        })
      )

      this.updateLiveRegions(line, parsedState.item_count)
      document
        .getElementById(`CartItem-${line}`)
        ?.querySelector(`[name="${name}"]`)
        ?.focus()
    }

    const statusBlock = document.querySelector('.js-product-totals')
    const qty = document.querySelector('.js-true-quantity-input')?.value || 0
    statusBlock?.updateText(parseInt(qty))
    document.querySelector('.js-cart-items-header').classList.add('active')

    this.bubble.innerHTML = parsedState.item_count
  }

  async getCartItems(itemKey) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js')
      const data = await response.json()
      const cartItems = data.items

      let discountKey

      cartItems.forEach((item) => {
        if (item.key === itemKey) {
          discountKey = item.line_level_discount_allocations[0]?.discount_application?.key
        }
      })

      let freeGWP = []
      cartItems.forEach((item) => {
        if (item.properties._buyxgety && item.line_level_discount_allocations[0]?.discount_application?.key === discountKey) {
          freeGWP.push(item.key)
        }
      })

      return freeGWP
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async updateQuantity(line, quantity, name, handle) {
    let updates = {
      [line]: quantity
    }

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        document.dispatchEvent(new CustomEvent('cart-updated'))
        this.renderCart(state, line, quantity, name)
        this.checkGwpThreshold().then((r) => r)
      })
      .catch(() => {
        if (document.getElementById('cart-errors')) {
          document.getElementById('cart-errors').textContent =
            window.cartStrings.error
        }
      }).finally(() => {
        this.bubble.innerHTML = window.__CART__.item_count
        document.dispatchEvent(new CustomEvent('cart:loaded'))
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        )
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  async checkGwpThreshold() {
    document.dispatchEvent(new CustomEvent('cart:loading'))
    const cart = window.__CART__
    const gwpItems = (cart.items || []).filter(
      (item) => item.properties?._gwp === 'true'
    )

    if (gwpItems.length === 0) {
      return "no_items"
    }

    const appliedOfferId = gwpItems[0].properties?._gwp_offer
    const appliedOffer = window.gwpOffers.find(
      (offer) => offer.offerId === appliedOfferId
    )
    const cartTotal = cart.items.reduce(
      (acc, item) => acc + item.final_price * item.quantity,
      0
    )
    const { threshold } = appliedOffer

    if (cartTotal < parseFloat(threshold) * 100) {
      const gwpToRemove = appliedOffer.items.map((item) =>
        parseInt(item.variant_id)
      )

      let updates = {}
      gwpItems.map((item) => {
        if (gwpToRemove.includes(item.variant_id)) {
          updates[item.key] = 0
        }
      })

      this.removeGwpInCart(updates).then((r) => {
        document.dispatchEvent(new CustomEvent('cart:loaded'))
      })
    }
  }

  async removeGwpInCart(updates) {
    const sectionsToRerender = {
      id: 'cart',
      section: document.getElementById('cart').dataset.id,
      selector: '.js-contents',
    }

    const body = JSON.stringify({
      updates,
      sections: [sectionsToRerender.section],
      sections_url: window.location.pathname,
    })

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)

        window.__CART__ = parsedState

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          if (!elementToReplace || !parsedState.sections[section.section])
            return

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })

        this.bubble.innerHTML = parsedState.item_count
      })
      .catch((e) => {
        console.error(e)
      })
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  loading(isLoading) {
    if (isLoading) {
      this.cartOverlay.classList.add('loading')
    } else {
      this.cartOverlay.classList.remove('loading')
    }
  }
}

customElements.define('cart-items', CartItems)

class CartCheckoutButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      this.classList.add('loading')

      const body = JSON.stringify({
        note,
      })
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
        .then((response) => (location.href = '/checkout'))
        .catch((e) => {
          this.classList.remove('loading')
          console.error(e)
        })
    })
  }
}

customElements.define('cart-checkout-button', CartCheckoutButton)
